import * as actionTypes from './actionTypes'

const initialState = {
  popularRestStops: [],
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.POPULAR_STOPS:
      return { ...state, popularRestStops: payload };
    case actionTypes.PLACE_SEARCH_RESULTS:
      return { ...state, placeSearchResults: payload.data };
      case actionTypes.MMI_KEY:
      return { ...state, mmiSignKey: payload };
      case actionTypes.ADD_REST_STOP:
      return { ...state, assignStopSuccess: payload.data };
      case actionTypes.DELETE_STOP:
        return { ...state, deletedStop: payload.data };
    default:
      return state
  }
}
